import React, { useEffect } from "react";
import {
  View,
  Text,
  ActivityIndicator,
  StyleSheet,
  Platform,
} from "react-native";
import { RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { useDispatch } from "react-redux";
import {
  paymentSuccess,
  paymentFailure,
} from "../../../store/packages/packagesActions";
import { RootStackParamList } from "../../navigator";
import LS from "../../../utils/localStorageUtils"; // важно: да е cross-platform (AsyncStorage на native)

type PaymentCallbackRouteProp = RouteProp<
  RootStackParamList,
  "PaymentCallback"
>;
type PaymentCallbackNavigationProp = NativeStackNavigationProp<
  RootStackParamList,
  "PaymentCallback"
>;

interface Props {
  route: PaymentCallbackRouteProp;
  navigation: PaymentCallbackNavigationProp;
}

export default function PaymentCallbackScreen({ route, navigation }: Props) {
  const dispatch = useDispatch();

  useEffect(() => {
    // 1) Опит: route params (native linking)
    const params = (route.params || {}) as any;

    const depositId: string | null =
      params.deposit_id || params.depositId || params.epayid || null;

    const paymentStatus: string | null =
      params.payment || params.status || null;

    // 2) Fallback за web ако някога го рендерираш там
    if (Platform.OS === "web" && (depositId == null || paymentStatus == null)) {
      try {
        const sp = new URLSearchParams(window.location.search);
        const did = sp.get("deposit_id") || sp.get("epayid");
        const st = sp.get("payment");
        handlePaymentCallback(did, st);
        return;
      } catch {}
    }

    handlePaymentCallback(depositId, paymentStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaymentCallback = async (
    depositId: string | null,
    paymentStatus: string | null
  ) => {
    if (paymentStatus === "success" && depositId) {
      try {
        const packageInfoStr = await LS.get(`package_${depositId}`); // LS трябва да връща string | null
        let parsedPackage: any = null;

        if (packageInfoStr) {
          try {
            parsedPackage = JSON.parse(packageInfoStr);
          } catch (e) {
            console.error("Failed to parse package info:", e);
          }
          await LS.remove(`package_${depositId}`);
        }

        dispatch(
          paymentSuccess({
            transactionId: depositId,
            package: parsedPackage,
          })
        );

        setTimeout(() => navigation.replace("PaymentSuccess"), 400);
      } catch (e) {
        console.error("Payment callback processing error:", e);
        dispatch(
          paymentFailure("Payment completed but failed to process package info")
        );
        setTimeout(() => navigation.replace("PaymentError"), 400);
      }
      return;
    }

    if (paymentStatus === "cancelled" || paymentStatus === "failed") {
      dispatch(paymentFailure("Payment was cancelled or failed"));
      setTimeout(() => navigation.replace("PaymentError"), 400);
      return;
    }

    navigation.replace("Lobby");
  };

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color="#00f0ff" />
      <Text style={styles.text}>Processing payment...</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#112345",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
  },
  text: {
    fontSize: 24,
    color: "#fff",
    marginTop: 20,
  },
});
